import cookies from 'js-cookie';

import {undef, hasValidDates} from './';

const LOCATION_COOKIE_NAME = 'ha-state-prst';
const SEARCH_COOKIE_NAME = 'ha-trip-prst';

function getDestinationValues(locationData) {
    if (locationData) {
        const {
            lbsKeywords
        } = locationData;

        if (lbsKeywords) {
            const destination = lbsKeywords.replace(/\+/g, ' ');

            return {
                destination
            };
        }
    }

    return {};
}

function getDatesValues(searchData) {
    if (searchData) {
        const {
            arrival: startDate,
            departure: endDate
        } = searchData;

        if (hasValidDates(startDate, endDate)) {
            return {
                startDate,
                endDate
            };
        }
    }

    return {};
}

// eslint-disable-next-line complexity
function getGuestsValues(searchData) {
    if (searchData) {
        let {
            numberOfAdults,
            numberOfChildren,
            petIncluded
        } = searchData;

        numberOfAdults = parseInt(numberOfAdults, 10);
        numberOfAdults = !isNaN(numberOfAdults) ? numberOfAdults : undef;

        if (numberOfAdults === 0 || numberOfAdults === undef) {
            return {};
        }

        numberOfChildren = parseInt(numberOfChildren, 10);
        numberOfChildren = !isNaN(numberOfChildren) ? numberOfChildren : undef;

        petIncluded = (typeof petIncluded === 'string') ? petIncluded === 'true' : petIncluded;

        return {
            adultsCount: numberOfAdults,
            childrenCount: numberOfChildren,
            petIncluded
        };
    }

    return {};
}

function getCookieValues() {
    const locationCookieData = cookies.getJSON(LOCATION_COOKIE_NAME);
    const searchCookieData = cookies.getJSON(SEARCH_COOKIE_NAME);

    const destinationValues = getDestinationValues(locationCookieData);
    const datesValues = getDatesValues(searchCookieData);
    const guestsValues = getGuestsValues(searchCookieData);

    return {
        destinationValues,
        datesValues,
        guestsValues
    };
}

function removeCookieKeys(name, keys) {
    const data = cookies.getJSON(name);

    if (data) {
        for (const key of keys) {
            delete data[key];
        }

        cookies.set(name, data);
    }
}

function removeSearchCookieDates() {
    removeCookieKeys(SEARCH_COOKIE_NAME, ['arrival', 'departure']);
}

export {
    LOCATION_COOKIE_NAME,
    SEARCH_COOKIE_NAME,
    getCookieValues,
    removeSearchCookieDates
};
